module.exports = __webpack_public_path__ + "static/media/UncheckedRadioIcon.9bbacd2b.svg";